import React from "react";

import withStyles from "@material-ui/styles/withStyles";

import {
  List,
  Datagrid,
  Filter,
  TextField,
  ReferenceInput,
  SelectInput,
  FilterButton,
  CreateButton,
  ShowButton,
  EditButton,
  FunctionField,
} from "jazasoft";
import { Role } from "../../utils/types";

const filters = (roles) => (
  <Filter>
    <ReferenceInput
      label="App"
      resource="apps"
      source="appId"
      reference="apps"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      xs={12}
      fullWidth
      options={{ fullWidth: true }}
    >
      <SelectInput />
    </ReferenceInput>
    {roles.includes(Role.MASTER) && (
      <ReferenceInput
        label="Tenant"
        resource="tenants"
        source="tenantId"
        reference="tenants"
        pageSize={100}
        sort={{ field: "name", order: "asc" }}
        xs={12}
        fullWidth
        options={{ fullWidth: true }}
      >
        <SelectInput />
      </ReferenceInput>
    )}
  </Filter>
);

const homeStyle = (theme) => ({
  buttonEdit: {
    width: theme.spacing(14),
  },
  buttonDelete: {
    width: theme.spacing(16),
  },
});

const UserHome = withStyles(homeStyle)(({ classes, ...props }) => {
  const roles = props.roles || [];
  return (
    <List
      searchKeys={["fullName", "username", "email"]}
      filters={roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) ? filters(roles) : null}
      actions={({ basePath, resource }) => (
        <div>
          <CreateButton basePath={basePath} showLabel={false} />
          {(roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER)) && <FilterButton showLabel={false} resource={resource} />}
        </div>
      )}
      parse={({ appId, tenantId }) => ({
        "appList.id": appId,
        "tenant.id": tenantId,
      })}
      {...props}
    >
      <Datagrid>
        <TextField source="fullName" />
        <TextField source="username" />
        <TextField source="email" />
        <TextField source="mobile" />
        <FunctionField label="Role" render={(record = {}) => record.roleList && record.roleList.map((r) => r.role && r.role.name).join(", ")} />
        {roles.includes(Role.MASTER) && <TextField label="Tenant" source="tenant.name" />}
        <ShowButton cellClassName={classes.buttonEdit} />
        <EditButton cellClassName={classes.buttonEdit} />
        {/* <DeleteButton cellClassName={classes.buttonDelete} /> */}
      </Datagrid>
    </List>
  );
});

export default UserHome;
